import { useQuery } from '@tanstack/react-query';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { ImpersonationBroker } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/search';

export function useLeadSearchQuery({
	search,
	enabled,
	meta,
	refetchOnWindowFocus,
}: {
	search: string;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, search],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ILeadSearchView[]>(
				ImpersonationBroker.composeApiUrl({ urlPath: `lead/search`, queryParams: { search } }),
				'GET'
			),
		enabled,
		meta,
		refetchOnWindowFocus,
	});
}
